import toast from 'react-hot-toast';
import { useNoticeStore } from '../store/noticeStore';

/**
 * Avisos de la aplicación.
 *
 * Estándar de la interfaz: un aviso es un **modal en el centro de la pantalla**
 * y **no se cierra solo**. Se queda hasta que la persona pulsa OK. Un mensaje
 * que se desvanece a los pocos segundos se pierde si estabas mirando otra parte
 * de la pantalla, y con él la única señal de que algo salió bien o mal.
 *
 * Usa siempre `notify`, nunca `toast` directamente:
 *   notify.success(t('imported_products.publish_success'))
 *   notify.error(mensajeDeError(error, t('stores.connect_failed')))
 *   notify.info(t('stores.sync_unavailable'))
 *
 * `notify.loading` es la excepción: marca un proceso en curso, no bloquea, y lo
 * cierra el código con `notify.dismiss(id)` cuando termina.
 */
export const notify = {
    success: (mensaje) => useNoticeStore.getState().push('success', mensaje),
    error: (mensaje) => useNoticeStore.getState().push('error', mensaje),
    info: (mensaje) => useNoticeStore.getState().push('info', mensaje),
    loading: (mensaje) => toast.loading(mensaje),
    dismiss: (id) => toast.dismiss(id)
};

export default notify;
